import {
  Newsletter,
  VideoPlayer,
  Tooltip,
  KlaviyoForm,
} from "../global";
import { buildBackedByScience } from "../sections";
import { initSection } from "../utils";
// Side-effect: boots count-up + ring when [js-our-impact] is on the page
import { buildOurImpact } from "../sections";
import logBeyondBrand from "@thebeyondgroup/brand";
// logBeyondBrand();

const bootGlobal = () => {
  initSection("newsletter-form", Newsletter);
  initSection("video-container", VideoPlayer);
  initSection("tooltip-info", Tooltip);
  initSection("klaviyo-form", KlaviyoForm);
  buildBackedByScience();
  buildOurImpact();

  if (document.querySelector("announcement-bar")) {
    document.body.classList.add("has-announcement", "has_announcement");
  }
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootGlobal);
} else {
  bootGlobal();
}